import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from './useAuth'

export function useAccounts() {
  const { user } = useAuth()
  const [accounts, setAccounts] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!user) return
    fetchAccounts()
  }, [user])

  async function fetchAccounts() {
    if (accounts.length === 0) setLoading(true)
    const { data, error } = await supabase
      .from('accounts')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at')
    if (!error && data) {
      if (data.length === 0) await seedDefaultAccounts()
      else setAccounts(data)
    }
    setLoading(false)
  }

  async function seedDefaultAccounts() {
    const defaults = ['Account 1', 'Account 2', 'Account 3', 'Account 4'].map(name => ({
      user_id: user.id, name, equity: 0,
    }))
    const { data } = await supabase.from('accounts').insert(defaults).select()
    if (data) setAccounts(data)
  }

  async function updateAccount(id, updates) {
    const { data, error } = await supabase
      .from('accounts')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single()
    if (!error && data) {
      setAccounts(prev => prev.map(a => a.id === id ? data : a))
    }
    return { error }
  }

  const totalEquity = accounts.reduce((sum, a) => sum + (a.equity || 0), 0)

  return { accounts, loading, updateAccount, totalEquity, refetch: fetchAccounts }
}
